<script setup lang="ts">
import { digitsOnly as vDigitsOnly } from '@/common/directives/digitsOnly'

defineProps<{
  externalSubjectCode: string
  externalSubjectName: string
  externalSubjectYear: string
  externalSubjectLevel: string
}>()

const emit = defineEmits<{
  'update:externalSubjectCode': [value: string]
  'update:externalSubjectName': [value: string]
  'update:externalSubjectYear': [value: string]
  'update:externalSubjectLevel': [value: string]
  subjectCodeBeforeInput: [event: Event]
}>()

function onExternalSubjectCodeInput(event: Event): void {
  emit('update:externalSubjectCode', (event.target as HTMLInputElement).value)
}

function onExternalSubjectNameInput(event: Event): void {
  emit('update:externalSubjectName', (event.target as HTMLInputElement).value)
}

function onExternalSubjectYearInput(event: Event): void {
  emit('update:externalSubjectYear', (event.target as HTMLInputElement).value)
}

function onExternalSubjectLevelChange(event: Event): void {
  emit('update:externalSubjectLevel', (event.target as HTMLSelectElement).value)
}
</script>

<template>
  <fieldset>
    <legend>Subject Details</legend>

    <div class="form-field requiredinput">
      <label for="externalSubjectCodeInput">What was the subject code?</label>
      <input
        required
        id="externalSubjectCodeInput"
        :value="externalSubjectCode"
        class="form-control"
        data-admissions-name="external_subject_code"
        data-admissions-group="SubjectInfo"
        @input="onExternalSubjectCodeInput"
        @beforeinput="emit('subjectCodeBeforeInput', $event)"
      >
    </div>

    <div class="form-field requiredinput">
      <label for="externalSubjectNameInput">What was the subject name?</label>
      <input
        required
        id="externalSubjectNameInput"
        :value="externalSubjectName"
        class="form-control"
        data-admissions-name="external_subject_name"
        data-admissions-group="SubjectInfo"
        @input="onExternalSubjectNameInput"
      >
    </div>

    <div class="form-field requiredinput">
      <label for="externalSubjectYearInput">What year did you complete this subject?</label>
      <input
        required
        id="externalSubjectYearInput"
        v-digits-only
        :value="externalSubjectYear"
        inputmode="numeric"
        pattern="[0-9][0-9][0-9][0-9]"
        class="form-control"
        data-admissions-name="external_subject_year"
        data-admissions-group="SubjectInfo"
        @input="onExternalSubjectYearInput"
      >
    </div>

    <div class="form-field requiredinput">
      <label for="externalSubjectLevelInput">What was the subject level?</label>
      <select
        required
        id="externalSubjectLevelInput"
        :value="externalSubjectLevel"
        class="form-select"
        data-admissions-name="external_subject_level"
        data-admissions-group="SubjectInfo"
        @change="onExternalSubjectLevelChange"
      >
        <option value="">Please Select</option>
        <option value="0">Diploma Subject / Non award / Zero Credit Points</option>
        <option value="1">1st Year Bachelors</option>
        <option value="2">2nd Year Bachelors</option>
        <option value="3">3rd Year Bachelors</option>
        <option value="4">4th Year Bachelors or 1st Year Postgraduate</option>
        <option value="5">2nd Year Postgraduate</option>
      </select>
    </div>
  </fieldset>
</template>
